var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallLabel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 10.1668C0.966667 10.1668 0.652778 10.0363 0.391667 9.77516C0.130556 9.51405 0 9.20016 0 8.8335V2.16683C0 1.80016 0.130556 1.48627 0.391667 1.22516C0.652778 0.964052 0.966667 0.833496 1.33333 0.833496H8C8.22222 0.833496 8.43056 0.883496 8.625 0.983496C8.81944 1.0835 8.97778 1.22238 9.1 1.40016L11.45 4.7335C11.6056 4.96683 11.6833 5.22238 11.6833 5.50016C11.6833 5.77794 11.6056 6.0335 11.45 6.26683L9.1 9.60016C8.97778 9.77794 8.81944 9.91683 8.625 10.0168C8.43056 10.1168 8.22222 10.1668 8 10.1668H1.33333ZM10.3667 5.50016L8 2.16683H1.33333V8.8335H8L10.3667 5.50016Z",
    fill: "white",
    fillOpacity: 0.74
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLabel);
export default __webpack_public_path__ + "static/media/smallLabel.86cd932d.svg";
export { ForwardRef as ReactComponent };